import axios from "axios";

/* ======================================
   🌐 HOST DETECTION
====================================== */

const hostname = window.location.hostname;

const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1";

/* ======================================
   🚀 AXIOS INSTANCE
====================================== */

const api = axios.create({
  baseURL: isLocal
    ? "http://localhost:5001/api"
    : "/api",

  withCredentials: true,
});



/* ======================================
   🔐 REQUEST INTERCEPTOR
====================================== */

api.interceptors.request.use(
  (config) => {

    console.log("\n=================================");
    console.log("🚀 AXIOS INTERCEPTOR START");
    console.log("=================================");

    // ✅ Token
    const token = localStorage.getItem("token");

    // ✅ User
    const user = JSON.parse(
      localStorage.getItem("user") || "{}"
    );

    console.log("🔑 TOKEN FROM STORAGE:", token);

    console.log("👤 USER FROM STORAGE:", user);

    // ✅ Attach Token
    if (token) {

      config.headers.Authorization =
        `Bearer ${token}`;

      console.log(
        "✅ Authorization Header Added"
      );

    } else {

      console.log("❌ No token found");

    }

    // ✅ Attach Tenant
    if (user?.tenantId) {

      config.headers["X-Tenant-Id"] =
        user.tenantId;

      console.log(
        "🏨 Tenant Header Added:",
        user.tenantId
      );

    } else {

      console.log("❌ No tenantId found");

    }

    console.log("📦 FINAL REQUEST CONFIG:", {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      headers: config.headers,
    });

    console.log("=================================");
    console.log("🚀 AXIOS INTERCEPTOR END");
    console.log("=================================\n");

    return config;
  },

  (error) => {

    console.log("❌ AXIOS INTERCEPTOR ERROR");

    return Promise.reject(error);
  }
);

/* ======================================
   ❌ RESPONSE INTERCEPTOR
====================================== */

api.interceptors.response.use(

  (response) => {

    console.log("\n=================================");
    console.log("✅ AXIOS RESPONSE SUCCESS");
    console.log("=================================");

    console.log("📦 RESPONSE:", response.data);

    console.log("=================================\n");

    return response;
  },

  (error) => {

    console.log("\n=================================");
    console.log("❌ AXIOS RESPONSE ERROR");
    console.log("=================================");

    console.log(
      "📊 STATUS:",
      error.response?.status
    );

    console.log(
      "📦 RESPONSE:",
      error.response?.data
    );

    console.log("=================================\n");

    // ✅ Auto logout safely
 const publicRoutes = [
  "/login",
  "/change-password",
  "/guest-portal",
  "/chef-order",
  "/housekeeping/task",
];

const isPublicRoute =
  publicRoutes.some(
    (route) =>
      window.location.pathname.startsWith(
        route
      )
  );

if (
  error.response?.status === 401 &&
  !isPublicRoute
) {

      console.warn(
        "🚫 Unauthorized — clearing session"
      );

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      sessionStorage.removeItem("authUser");

     console.error(
  "401 REDIRECT TRIGGERED",
  {
    pathname: window.location.pathname,
    url: error.config?.url,
    status: error.response?.status,
  }
);

debugger;

window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);

/* ======================================
   🧠 DEBUG LOG
====================================== */

console.log("🚀 AXIOS CONFIG:", {
  hostname,
  isLocal,
  baseURL: api.defaults.baseURL,
});

/* ======================================
   EXPORT INSTANCE
====================================== */

export default api;